import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'
import { PublicInterceptorPR } from '../../../Base/interceptors/PublicInterceptorsPR';

export const getPersonal = async () => {
    const response = await PrivateInterceptor('Payrolls/personal', 'GET');
    return response
}

export const getPersonalById = async (id) => {
    const response = await PrivateInterceptor(`Payrolls/personal/${id}`, 'GET');
    return response
}

export const getPersonalToken = async (token) => {
    const result = await PublicInterceptorPR(`Payrolls/personal`, 'GET', {}, token);
    return result;
}

export const getPersonalRecibeProducto = async () => {
    const response = await PrivateInterceptor('Payrolls/personal/RecibeProducto', 'GET');
    return response
}
